import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import { addBooking, getFinancialAction, getInvoiceTypeListAction, getPaymentMethodListAction, getQuickBookDetails, postFinancialAction, setAddBookingResponse, setFinancialDetails, setInvoiceTypeListAction, setPaymentMethodListAction, setPostFinancialResponse, setQuickBookDetails } from "../reducers/quickBookSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* addBookingSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {payload},
      "post",
      "account/quickbook"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddBookingResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setAddBookingResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getQuickBookDetailsSaga():any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `account/quickbook/`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      yield put(setQuickBookDetails(apiResponse?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
      yield put(setLoaderAction(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setLoaderAction(false));
    yield put(setQuickBookDetails({}));
  }
  yield put(setLoaderAction(false));
}

function* getFinancialSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      "client/settings/financial"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      yield put(setFinancialDetails(apiResponse?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setFinancialDetails({}));
  }
  yield put(setLoaderAction(false));
}

function* getInvoiceTypeListSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      "client/invoice-types"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      yield put(setInvoiceTypeListAction(apiResponse?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setInvoiceTypeListAction([]));
  }
  yield put(setLoaderAction(false));
}

function* getPaymentMethodListSaga(): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      "client/payment-methods"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // apiResponse && handleSuccess(apiResponse);
      yield put(setPaymentMethodListAction(apiResponse?.data));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    // error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setPaymentMethodListAction([]));
  }
  yield put(setLoaderAction(false));
}

function* postFinancialSaga({ payload }: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("Payload in saga-", payload);
  const {} = payload;
  try {
    const apiResponse = yield call<any>(
      callAPI,
      { payload },
      "post",
      "client/settings/financial"
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setPostFinancialResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}



export function* watchQuickBook() {
    yield takeLatest<any>(addBooking, addBookingSaga);
    yield takeLatest<any>(getQuickBookDetails, getQuickBookDetailsSaga);
    yield takeLatest<any>(getFinancialAction, getFinancialSaga);
    yield takeLatest<any>(getInvoiceTypeListAction, getInvoiceTypeListSaga);
    yield takeLatest<any>(getPaymentMethodListAction, getPaymentMethodListSaga);
    yield takeLatest<any>(postFinancialAction, postFinancialSaga);
}